const Burgers = [
  // 🥩 Burgers classiques
  { name: 'Hamburger', price: 2.80 },
  { name: 'Cheese Burger', price: 3.30 },
  { name: 'Crispy burger', price: 3.10 },
  { name: 'Crispy cheese burger', price: 3.60 },

  // 🔥 Boeuf / poulet / veggie (grill)
  { name: 'Beef Burger simple', price: 3.20 },
  { name: 'Crunchy chicken burger', price: 4.60 },
  { name: 'Bicky burger', price: 4.00 },
  { name: 'Végi burger', price: 5.00 },
  { name: 'Géant de Lalaing burger', price: 6.00 },
  { name: 'Bicky Crispy Royal', price: 8.50 },
  { name: 'Super géant de Lalaing burger', price: 8.50 },

  // 🧱 Burgers seuls (sans pain)
  { name: 'Burger pur boeuf 55gr seul', price: 2.00 },
  { name: 'Burger pur boeuf 113gr seul', price: 3.00 },
  { name: 'Burger viande seul', price: 2.10 },
  { name: 'Crunchy chicken seul', price: 3.20 },
  { name: 'Crispy seul', price: 2.30 },
  { name: 'Crispy Royal seul', price: 5.00 },
  { name: 'Végi burger seul', price: 3.50 },

  // 🌟 Burgers spéciaux / du mois
  { name: 'Burger Comté-Parmesan', price: 7.20 },
  { name: 'Le Barbara – 1 viande', price: 7.00 },
  { name: 'Le Barbara – 2 viandes', price: 9.50 },
  { name: 'Le Bob', price: 8.00 },
  { name: 'Burger Chèvre-miel – 1 viande', price: 7.00 },
  { name: 'Burger Chèvre-miel – 2 viandes', price: 9.50 }
]

export default Burgers